import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { BasketDiscountSummary } from 'autogen/swagger/all';
import { TotalDiscount } from 'autogen/translation-keys/trans-website-basket';
import { Price } from 'components/generic/productPrice';
import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';

const StyledBody = styled(Typography.Body)`
    font-style: italic;
`;

const StyledPrice = styled(Price)`
    font-style: italic;
    font-weight: normal;
`;

type TotalDiscountSummary = Record<string, any> & { model: BasketDiscountSummary };

export default function TotalDiscountSummary({ model: { total }, ...restProps }: TotalDiscountSummary) {
    const { t } = useTranslation();

    return (
        <Layout.Flex.Row justifyContent="space-between" alignItems="center" {...restProps}>
            <StyledBody forwardedAs="span" size="M">
                {t(TotalDiscount)}
            </StyledBody>
            <StyledPrice price={total} />
        </Layout.Flex.Row>
    );
}
